import { api } from "./baseApi";
export var coinTransactionApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            // 🔹 Получить все транзакции
            getAllCoinTransactions: builder.query({
                query: function () {
                    return ({
                        url: "/coinTransaction",
                        method: "GET",
                    });
                },
                providesTags: ["CoinTransactions"],
            }),
            // 🔹 Получить транзакции с пагинацией
            getCoinTransactionsWithPagination: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit;
                    return ({
                        url: "/coinTransaction/allwithPagination",
                        method: "GET",
                        params: { page: page, limit: limit },
                    });
                },
                providesTags: ["CoinTransactions"],
            }),
            // 🔹 Создать транзакцию
            createCoinTransaction: builder.mutation({
                query: function (body) {
                    return ({
                        url: "/coinTransaction",
                        method: "POST",
                        body: body,
                    });
                },
                invalidatesTags: ["CoinTransactions"],
            }),
        });
    },
});
export var useGetAllCoinTransactionsQuery = coinTransactionApi.useGetAllCoinTransactionsQuery, useGetCoinTransactionsWithPaginationQuery = coinTransactionApi.useGetCoinTransactionsWithPaginationQuery, useCreateCoinTransactionMutation = coinTransactionApi.useCreateCoinTransactionMutation;
